export function getMarkSpecificConfigMixins(markSpecificConfig, channel) {
    var _a;
    var value = markSpecificConfig[channel];
    return value !== undefined ? (_a = {}, _a[channel] = { value: value }, _a) : {};
}
//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-lite/build/src/compositemark/common.js
// module id = 937
// module chunks = 0